import React, { Component } from 'react'
import ReactTooltip from 'react-tooltip'
import './Stores.css'
import * as languageSettings from '../Language/languageSettings'
import t from '../Language/language'
import { Config } from '../../Config'
import AuthenticationService from '../Security/AuthenticationService'
import NavigationService from '../Common/NavigationServices'
export default class CommonStoreMethod extends Component {
  constructor (props) {
    super(props)
    this.state = {
      language: languageSettings.getCurrentLanguage()
    }
    this.navigate = new NavigationService()
    this.authService = new AuthenticationService(Config.authBaseUrl)
  }
  // Checking the device status and remote connect permission and the Device_Name CIB.
  // This function is used in CIB and Zoom Components.
  renderStatus (device, isRemoteConnection) {
    const { language } = this.state
    if (device.Device_IsActive === 1) {
      // For Admin, allowing the remote connect permission.
      if (this.authService.isAdmin()) {
        return (<a style={{ 'textAlign': 'center', color: parseInt(device.Device_IsActive, 10) === 1 ? 'red' : 'black' }} href={this.navigate.getMenu('connect', device.Device_UID)}>{parseInt(device.Device_IsActive, 10) === 1 ? (t[language].settingsStoresOnline) : t[language].settingsStoresOffline}</a>)
      } else { // For normal users - checking the remote connect permission.
        if (isRemoteConnection && device.Device_Name !== 'CIB') {
          return (<a style={{ color: parseInt(device.Device_IsActive, 10) === 1 ? 'red' : 'black' }} href={this.navigate.getMenu('connect', device.Device_UID)}>{device.Device_IsActive ? t[language].settingsStoresOnline : t[language].settingsStoresOffline}</a>)
        } else {
          return (<span style={{ color: 'black' }}>{device.Device_IsActive ? t[language].settingsStoresOnline : t[language].settingsStoresOffline}</span>)
        }
      }
    } else {
      return (<span style={{ color: 'black' }}>{device.Device_IsActive ? t[language].settingsStoresOnline : t[language].settingsStoresOffline}</span>)
    }
  }
  // Showing the device headers.
  // This function is used in CIB and Zoom Components.
  renderDeviceListHeaders () {
    const { language } = this.state
    return (
      <tr className='theader'>
        <th />
        <th>{t[language].settingsStoresSystemVersion}</th>
        <th>{t[language].settingsStoresSerialNumber}</th>
        <th>{t[language].settingsStoresSystemStatus}</th>
        <th />
      </tr>
    )
  }

  formatText (text) {
    if (text) {
      if (text.length > 15) {
        let formattedText = text.substring(0, 15) + ' ...'
        return formattedText
      } else {
        return text
      }
    } else {
      return text
    }
  }
  // Showing the tool tip with name onhover ... (3 dots)
  // This function is used in Store detail admin and Store merge Components.
  renderText (text) {
    if (text.length > 15) {
      return (<div>
        <span data-tip={text} className='tooltipText'><span>{this.formatText(text)}</span></span>
        <ReactTooltip place='top' type='light' effect='solid' data-place='top' />
      </div>)
    } else {
      return (<span>{text}</span>)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Stores/CommonStoreMethod.js